import {
  POST_PROJECTS_CATALOG,
  POST_PROJECTS_CATALOG_SUCCESS,
  POST_PROJECTS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postProjectsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case POST_PROJECTS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_PROJECTS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_PROJECTS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
